import React, { useEffect, useCallback, } from "react";

import { Button, Grid, DialogContent, Fab, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { isMobile, isMobileOnly } from "react-device-detect";

import Modal from "../../HOC/modal/Modal";
import Login from "./Login";
import useStyles from "./Header.styles";
import session from "../../utils/session";
import {
  refreshMetamaskLoginStart,
  resetSuccess,
  handleOpenSignUpRedux,
  handleOpenLoginRedux,
  resetLoginRedux,
  refreshLoginStart
} from "../../redux-saga/redux/auth/authentication";
import Wallet from "./Wallet";
import AccountDropdown from "./Dropdown/AccountDropdown";
// import LanguageDropdown from "./Dropdown/LanguageDropdown";
// import MobSidebar from "./MobSidebar";
import {
  getSubCategoryStart,
  resetReferralCode
} from "../../redux-saga/redux/casino/lobby/casinoLobby";
import Contact from "./Contact";
import { getUserProfileDetailsStart } from "../../redux-saga/redux/profile/myProfile";
import BetLimit from "./Dropdown/BetLimit";
import BrandLogo from "../../container/SportsBookNode/BrandLogo";
import BrandLogoMob from "../../container/SportsBookNode/BrandLogo/BrandLogoMob";
// import { CRASH_GAME } from "../../utils/constants";
// import MobSubHeader from "./MobSubHeader";
import ThemeSelect from "./ThemeSelect/themeSelect";
import gift from "../../assets/images/Gift.svg";

const Header = () => {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isGameLaunch =
    location.pathname.includes("/game") ||
    location.pathname.includes("/provider-lobby");

  // const [openLogin, setOpenLogin] = useState(false);
  // const [openMobileSidebar, setMobileSidebar] = useState(false);

  const {
    loading,
    metamaskLoading,
    isLoggedIn,
    metamaskConnected,
    metamaskLoggedIn,
    success,
    signup,
    metamaskSuccess,
    openLogin
  } = useSelector((state) => state.authentication);

  const { orientation } = useSelector((state) => state.settings);
  const { isGameStarted } = useSelector((state) => state.casinoGames);
  const subCategories = useSelector((state) => state.casinoLobby.subCategory);
  // const carshGameSubCategoryId = useMemo(() => {
  //   return subCategories?.filter(
  //     (game) => game?.name?.toLowerCase() === CRASH_GAME.nameKey
  //   )?.[0]?.masterGameSubCategoryId;
  // }, [subCategories]);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const handleOpenLogin = useCallback(() => {
    // setOpenLogin((prevState) => !prevState);
    dispatch(handleOpenLoginRedux());
  }, [dispatch]);

  const handleOpenSignUp = useCallback(() => {
    dispatch(handleOpenSignUpRedux());
    // setOpenSignUp((prevState) => !prevState);
  }, [dispatch]);

  // const handleToggleMobileSidebar = useCallback(() => {
  //   setMobileSidebar((prevState) => {
  //     if (!prevState) {
  //       document.body.style.overflow = "hidden";
  //     }
  //     if (prevState) {
  //       document.body.style.overflow = "scroll";
  //     }
  //     return !prevState;
  //   });
  // }, []);

  useEffect(() => {
    if (!isLoggedIn && token) {
      dispatch(refreshLoginStart({ thirdPartyToken: token }));
    }
  }, [dispatch, isLoggedIn, token]);

  useEffect(() => {
    if (isLoggedIn && success) {
      // setOpenLogin(false);
      dispatch(resetLoginRedux());
      dispatch(resetSuccess());
    }

    if (metamaskLoggedIn && metamaskSuccess) {
      // setOpenLogin(false);
      dispatch(resetLoginRedux());

      dispatch(resetSuccess());
    }

    if (success && !isLoggedIn && !metamaskLoggedIn) {
      dispatch(resetSuccess());
      setTimeout(() => {
        navigate("/");
      }, 1000);
    }

    if (signup && success) {
      // setOpenSignUp(false);
      dispatch(handleOpenSignUpRedux());
      dispatch(resetSuccess());
      dispatch(resetReferralCode());
    }
  }, [
    dispatch,
    isLoggedIn,
    success,
    signup,
    loading,
    metamaskLoading,
    metamaskConnected,
    t,
    navigate,
    metamaskLoggedIn,
    metamaskSuccess
  ]);

  useEffect(() => {
    if (session.getSessionCred) {
      const user = session.getSessionCred;
      if (user.isMetaMaskUser) {
        dispatch(refreshMetamaskLoginStart());
      } else {
        dispatch(getUserProfileDetailsStart({ walletLoading: true }));
      }
    }
  }, [dispatch, isLoggedIn]);

  const handleOpenBonus = useCallback(() => {
    navigate("/user/bonus");
  }, [navigate]);

  useEffect(() => {
    if (!subCategories?.length && isLoggedIn) dispatch(getSubCategoryStart());
  }, [dispatch, isLoggedIn, subCategories?.length]);

  if (isMobile && isGameStarted && orientation !== "PORTRAIT") {
    return null;
  }
  if (!isLoggedIn) return;
  return (
    <div className={classes.headerWrap}>
      <Grid className={classes.header}>
        <Grid className={classes.headerLeft}>
          {/* MOBILE SIDEBAR TOGGLE BUTTON START FROM HERE */}
          {/* <Grid
            className={classes.mobToggle}
            onClick={handleToggleMobileSidebar}
          >
            <img src="/images/menu-icon.webp" alt="Menu Icon" />
          </Grid> */}
          {/* MOBILE SIDEBAR TOGGLE BUTTON END HERE */}
          <Link aria-label="Home" to="/" className={classes.headerLogo}>
            {isMobileOnly ? <BrandLogoMob /> : <BrandLogo />}
          </Link>
        </Grid>
        {isGameLaunch ? (
          <Button
            disableRipple
            className={classes.gameCloseBtn}
            onClick={() => {
              navigate(-1);
              setTimeout(() => {
                window.scroll({ top: 0, behavior: "smooth" });
              }, 100);
            }}
          >
            <img src="/images/iframe-close.webp" alt="Cross" />
          </Button>
        ) : (
          <Grid className={classes.headerRight}>
            {!process.env?.REACT_APP_THEME && !isMobile && <ThemeSelect />}
            {isLoggedIn || metamaskLoggedIn ? (
              <>
                <Contact handleOpenSignUp={handleOpenSignUp} />
                {!isMobile && (
                  <Tooltip
                    arrow
                    classes={{
                      tooltip: classes.toolTipWrap,
                      arrow: classes.toolTipArrow
                    }}
                    title={t("HEADER.MY_BONUS")}
                    placement="bottom"
                  >
                    <Fab
                      size="small"
                      onClick={handleOpenBonus}
                      sx={{
                        background: theme?.palette?.appHeaderButtonBG?.red,
                        color: theme?.palette?.appHeaderText?.main,
                        minWidth: 40,
                        height: 40,

                        "& img": {
                          filter: "brightness(0) invert(1)",
                          transition: "filter 0.3s ease"
                        },

                        "&:hover": {
                          background: theme?.palette?.appHeaderButtonBG?.active,
                          color: theme?.palette?.appHeaderText?.active,

                          "& img": {
                            filter: "brightness(0)"
                          }
                        }
                      }}
                    >
                      <img
                        src={gift}
                        alt="bonus"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </Fab>
                  </Tooltip>
                )}
                <BetLimit />
              </>
            ) : null}
            {/* <LanguageDropdown /> */}
            {!isLoggedIn &&
              !loading &&
              !metamaskLoggedIn &&
              !metamaskLoading ? (
              <>
                <Button
                  className={classes.btnPrimary}
                  onClick={handleOpenLogin}
                >
                  {t("HEADER.LOGIN")}
                </Button>
              </>
            ) : null}
            {isLoggedIn || metamaskLoggedIn ? (
              <>
                <Wallet />
                <AccountDropdown isLoggedIn={isLoggedIn} />
              </>
            ) : null}
          </Grid>
        )}

        {/* MOBILE SIDEBAR START FROM HERE */}
        {/* <MobSidebar
          handleToggleMobileSidebar={handleToggleMobileSidebar}
          openMobileSidebar={openMobileSidebar}
          isLoggedIn={isLoggedIn}
          metamaskLoggedIn={metamaskLoggedIn}
        /> */}
        {/* MOBILE SIDEBAR END HERE */}
      </Grid>
      {/* <MobSubHeader carshGameSubCategoryId={carshGameSubCategoryId} /> */}
      <Modal
        isShowing={openLogin}
        maxWidth={isMobile ? "85%" : ""}
        maxHeight={isMobile ? "90%" : ""}
        content={
          <DialogContent className={classes.loginWrap}>
            <Login
              handleCloseLogin={handleOpenLogin}
              handleOpenSignUp={handleOpenSignUp}
            />
          </DialogContent>
        }
        hide={handleOpenLogin}
      />
    </div>
  );
};

export default Header;
